/**
 * Group-landing host detection.
 *
 * Production:  go.meitre.com
 * Staging:     go.meitre-test.com (when provisioned)
 * Local dev:   localhost:8080?group=1
 *
 * The group host serves tenant-less, multi-restaurant landing pages
 * (e.g. go.meitre.com/mx). It must NOT mount TenantProvider/TenantGuard.
 */

/** Pure: does this hostname denote the group host? Testable regardless of env. */
export function isGroupHostname(hostname: string): boolean {
  return hostname.startsWith('go.');
}

export function isGroupHost(): boolean {
  if (import.meta.env.DEV) {
    return new URLSearchParams(window.location.search).has('group');
  }
  return isGroupHostname(window.location.hostname);
}
